// ABOUTME: Silent renewal of the Auth0 id_token the API accepts, through the user's Auth0 session.
// ABOUTME: Kept apart from auth.service so the RTK baseQuery can use it without an import cycle.
import { Auth0Error, Auth0Result, CheckSessionOptions } from 'auth0-js';
import auth0Client from '../Auth0.config';

const redirectUriLogin = `${window.location.origin}/login`;
const responseType = 'id_token';

// Without a nonce, auth0-js generates one and checks it against the returned token.
export const checkSession = (nonce?: string): Promise<any> =>
  new Promise((resolve, reject) => {
    auth0Client.checkSession(
      // auth0-js waits 60s for an answer by default; its typings omit `timeout`.
      {
        nonce,
        redirectUri: redirectUriLogin,
        responseType,
        timeout: 10000,
      } as CheckSessionOptions,
      (error: Auth0Error | null, authResult: Auth0Result) => {
        if (error) {
          reject(error);
        }
        if (authResult) {
          resolve(authResult);
        }
      }
    );
  });

let pendingRenewal: Promise<string | null> | undefined;

// Gets a fresh id_token from the user's Auth0 session and stores it where the app reads it.
// Resolves null when Auth0 has no session to renew. Concurrent callers share one renewal.
export const renewIdToken = (): Promise<string | null> => {
  if (!pendingRenewal) {
    pendingRenewal = checkSession()
      .then(({ idToken }: Auth0Result) => {
        const auth0User = localStorage.getItem('Auth0User');
        // The user logged out while the renewal was in flight.
        if (!idToken || (!auth0User && !localStorage.getItem('id_token'))) {
          return null;
        }
        localStorage.setItem('id_token', idToken);
        if (auth0User) {
          localStorage.setItem(
            'Auth0User',
            JSON.stringify({ ...JSON.parse(auth0User), idToken })
          );
        }
        return idToken;
      })
      .catch(() => null)
      .finally(() => {
        pendingRenewal = undefined;
      });
  }
  return pendingRenewal;
};
